<template>
  <ModalComponent
    ref="modalRef"
    submitButtonText="Submit request"
    :submit="onConfirm"
    @close="$emit('close')"
  >
    <template #title>Submit sourcing request</template>
    <template #body>
      <table class="table table-sm mb-3 cg-key-table">
        <tbody class="cg-tabular">
          <tr>
            <td class="text-body-secondary">Volume requested from Soldera</td>
            <td>{{ fmt(volume) }} MWh</td>
          </tr>
          <tr>
            <td class="text-body-secondary">
              Lines · required production months
            </td>
            <td>1 · {{ month }}</td>
          </tr>
          <tr>
            <td class="text-body-secondary">Purchasing entity</td>
            <td>Northwind Demo France SAS</td>
          </tr>
          <tr>
            <td class="text-body-secondary">Committed spend</td>
            <td>None</td>
          </tr>
        </tbody>
      </table>
      <div class="alert alert-secondary small mb-0">
        Soldera returns a firm quote for separate approval before any volume is
        bought.
      </div>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import { fmt } from "@/compliance_groups/fixture/format";
import ModalComponent from "@/components/common/ModalComponent.vue";
import { onMounted, useTemplateRef } from "vue";

defineProps<{ volume: number; month: string }>();
const emit = defineEmits<{ confirm: []; close: [] }>();
const modalRef =
  useTemplateRef<InstanceType<typeof ModalComponent>>("modalRef");
onMounted(() => modalRef.value?.toggleModal());
const onConfirm = () => {
  modalRef.value?.toggleModal();
  emit("confirm");
};
</script>
